import token, { tokenToVars } from '../token';
import CardGroup from './card-group';

export { CardGroup };
export default tokenToVars(CardGroup, token);
